import { createFileRoute, redirect } from "@tanstack/react-router";

// The app has no landing page at the base root ("/"). Users hard-loading the
// deploy root (e.g. https://admin.zypl.ai/dev/) must land on a real route so
// the SPA shell can hydrate and recover; without this the root falls through to
// the root notFoundComponent, whose redirect doesn't survive hydration and the
// page renders blank. Redirect to /login — the guest layout bounces already
// authenticated users on to /applications.
export const Route = createFileRoute("/")({
	beforeLoad: () => {
		throw redirect({ to: "/login" });
	},
});
